import { render, staticRenderFns } from "./StatistikLernendeModal.vue?vue&type=template&id=6b014a46"
import script from "./StatistikLernendeModal.vue?vue&type=script&lang=js"
export * from "./StatistikLernendeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports